import DynamicForm from '../components/dynamicForm';

const CompaniesVIPSales = () => {
  const fields = [
    { id: 'name', type: 'text', placeholder: 'الاسم', required: true },
    { id: 'mobile', type: 'phone', placeholder: 'رقم الجوال', required: true },
    { id: 'city', type: 'text', placeholder: 'المدينة', required: true },
    { id: 'email', type: 'email', placeholder: 'البريد الإلكتروني', required: true },
    { id: 'businessType', type: 'select', placeholder: 'نوع النشاط', options: [{ label: 'محل تجاري', value: 'محل تجاري' }, { label: 'موقع إلكتروني', value: 'موقع إلكتروني' }], required: true },
    { id: 'website', type: 'url', placeholder: 'رابط الموقع الإلكتروني', dependentOn: 'businessType',dependencyValues: ['موقع إلكتروني'], required: true},    
    { id: 'businessDoc', type: 'file', placeholder: 'السجل التجاري أو وثيقة العمل الحر', acceptFiles: 'image/*', required: true },

  ];

  return (
    <DynamicForm
      formType="ComVipSales"
      fields={fields}
      title="مبيعات الشركات وكبار العملاء"
    />
  );
};

export default CompaniesVIPSales;
